import { Component, OnInit, effect, signal } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromCheers from 'app/state/cheers';
import { IToastCheers } from 'app/models/cheers';

@Component({
  selector: 'app-cheers-toast',
  templateUrl: './cheers-toast.component.html',
  styleUrls: ['./cheers-toast.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class CheersToastComponent {

  activeToast = this.store.selectSignal(fromCheers.selectActiveToast);
  isVisible = signal(false);

  private timeoutId: any;

  constructor(private store: Store) {
    effect(() => {
      const toast = this.activeToast();
      if (toast) {
        this.showToast(toast);
      } else {
        this.isVisible.set(false);
      }
    }, { allowSignalWrites: true });
  }

  showToast(toast: IToastCheers) {
    this.isVisible.set(true);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      if (this.activeToast()?.id === toast.id) {
        this.confirmToast(toast);
      }
    }, 4000);
  }

  confirmToast(toast: IToastCheers) {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.store.dispatch(fromCheers.executeToastCheckout({ toast }));
    this.store.dispatch(fromCheers.removeToast({ id: toast.id }));
  }

  undoToast(toast: IToastCheers, event: Event) {
    event.stopPropagation();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    // Just remove it without executing
    this.store.dispatch(fromCheers.removeToast({ id: toast.id }));
  }
}
